import React, {useCallback} from 'react';
import {Button, Flex, Text} from '@priority-software/priority-style-react';
import styles from '../styles.module.scss';
import EmailTemplateIcon from '../icons/EmailTemplate';
import {INewEmailTemplate} from '../NewEmailTemplate';
import {isRTL} from '../../../../../../../../../../Localization';
import {createDataTestId} from '../../../../../../../../../../utils/dataTestId';
import {texts} from '../../../../../../../../../EmailEditor/texts';

export const useNewEmailTemplate = ({handleEmailDialog, subject}: INewEmailTemplate) => {
    const renderIcon = useCallback(
        () => (
            <div style={{flexShrink: 0}}>
                <EmailTemplateIcon height="175" width="192" />
            </div>
        ),
        []
    );

    const renderSubject = useCallback(
        () => (
            <Flex
                direction="column"
                alignItems="flex-start"
                componentClasses={styles.subjectContainer}
            >
                <Text textColor="secondary-500" skin="label-1">
                    {texts.email_subject_label}
                </Text>
                <Text
                    {...createDataTestId(`new-email-subject-text`, true)}
                    componentClasses={styles.subjectTemplate}
                    skin="paragraph-2"
                >
                    {subject || texts.email_subject_placeholder}
                </Text>
            </Flex>
        ),
        [subject]
    );

    const renderButtons = useCallback(
        () => (
            <Button
                {...createDataTestId(`new-email-edit-button`, true)}
                onClick={handleEmailDialog}
                size={'small'}
                componentClasses={isRTL() ? styles.marginLeft : styles.marginRight}
            >
                {texts.email_edit_mail_button}
            </Button>
        ),
        []
    );

    return {renderIcon, renderSubject, renderButtons} as const;
};
